import { html, LitElement } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-vehicle-and-loan-mfe';
import { DebugService } from '../../../shared/services/debug.service.js';
import { style } from './vehicle-consent.style.js';
import { REFI_VEHICLE_LOAN_CONST } from '../../../shared/constants/app.constants.js';
import { validateForm } from '../../../shared/decorators/validate-form.decorator.js';
import { preventEvDefault } from '../../../shared/decorators/prevent-ev-default.decorator.js';
import { vibrate } from '../../../shared/decorators/vibrate.decorator.js';
import { SessionService } from '../../../core/services/session/session.service.js';
import { stratum } from '../../../../constants/stratum.js';
import { ApplicationService } from '../../../services/application.service.js';

class RefiVehicleConsent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiVehicleConsent');
    this.application = {};
  }

  static properties = {
    application: { type: Object, reflect: true },
  };

  static styles = [style];

  firstUpdated() {
    stratum.publishTag(
      ApplicationService.isInAppDeclineDelayOn
        ? TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_CONSENT_2
        : TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_CONSENT
    );
  }

  connectedCallback() {
    super.connectedCallback();
    this.application = ApplicationService.Application;
  }

  updateConsent(e) {
    this.debug.log(`vehicle consent set to ${e?.target?.checked}`);
    this.application.agreeToLookup = e?.target?.checked;
  }

  @preventEvDefault()
  @vibrate(50)
  @validateForm()
  /* prettier-ignore */
  nextStep(e) {
    this.debug.log('form is valid', e);
    this.saveVehicleConsent();
    this.dispatchEvent(new CustomEvent('next-step'));
  }

  saveVehicleConsent() {
    REFI_VEHICLE_LOAN_CONST.TRACK_EVENT(
      'Vehicle and loan consent clicked Agree'
    );
    ApplicationService.Application.agreeToLookup = true;
    SessionService.setVehicleConsent(true);
    stratum.publishTag(
      ApplicationService.isInAppDeclineDelayOn
        ? TagKey.VEHICLE_LOAN_CONSENT_LOOKUP_CONSENT_2
        : TagKey.VEHICLE_LOAN_CONSENT_LOOKUP_CONSENT
    );
  }

  render() {
    this.debug.log('rendered');
    return html`
      <refi-track-pageview
        pagename="vehicle and loan consent"
      ></refi-track-pageview>
      ${ApplicationService.isUpfrontOffers
        ? html` <refi-heading
              size="medium"
              variant="primary"
              class="ufo-consent-heading"
            >
              Let's find your car.
            </refi-heading>
            <fs-body-text
              size="small"
              variant="primary"
              class="ufo-consent-text"
            >
              We’ll look up your car and loan info to show you personalized
              monthly payment options before you apply.
            </fs-body-text>
            <form class="consent-form" novalidate @submit="${this.nextStep}">
              <img class="center-img" src="assets/vehicle-lookup.svg" alt="" />
              <fs-modal-dialog
                accessible-title="Agree to Vehicle and Loan lookup"
                size="small"
                dismissible=""
              >
                <div class="center-button">
                  <fs-button type="button" id="open" @click="findCarClick()"
                    >Find my car</fs-button
                  >
                </div>
                <refi-heading
                  slot="modal-dialog-header"
                  class="ufo-consent-heading__modal"
                >
                  We just need your OK to find your vehicle and loan
                </refi-heading>
                <section
                  class="fs-body-text fs-body-text--normal"
                  slot="modal-dialog-body"
                >
                  <refi-input
                    focus-initial=""
                    slot="checkbox"
                    type="checkbox"
                    id="personalTermsUFO"
                    name="personalTermsUFO"
                    value="true"
                    label="${REFI_VEHICLE_LOAN_CONST.UFO_CONSENT_LABEL}"
                  >
                  </refi-input>
                </section>
                <refi-modal-dialog-footer
                  footer-layout-swap-breakpoint="medium"
                  slot="modal-dialog-footer"
                  class="fs-modal-dialog__footer--action-layout-stacked"
                >
                  <div class="consent-submit modal">
                    <fs-button
                      focus-initial=""
                      variant="primary"
                      type="submit"
                      class="ufo-submit-button"
                    >
                      Agree
                    </fs-button>
                  </div>
                </refi-modal-dialog-footer>
              </fs-modal-dialog>
            </form>`
        : html`<refi-heading class="consent-heading">
              We need your okay to find your vehicle and loan.
            </refi-heading>
            <form class="consent-form" novalidate @submit="${this.nextStep}">
              <refi-input
                slot="checkbox"
                type="checkbox"
                id="vehicleConsent"
                name="vehicleConsent"
                label="${ApplicationService.isJointApplication
                  ? 'I and my co-applicant agree that:'
                  : 'I agree that:'}"
                required-message="Please agree to the terms below"
              ></refi-input>
              <ul class="consent-terms">
                ${(ApplicationService.isJointApplication
                  ? REFI_VEHICLE_LOAN_CONST.JOINT_VEHICLE_CONSENT_TERMS
                  : REFI_VEHICLE_LOAN_CONST.VEHICLE_CONSENT_TERMS
                ).map((term) => html`<li class="consent-term">${term}</li>`)}
              </ul>
              <div class="consent-submit">
                <fs-button data-e2e-ref="submitConsent" variant="primary"
                  >Next</fs-button
                >
              </div>
            </form>`}
    `;
  }
}
customElements.define('refi-vehicle-consent', RefiVehicleConsent);
